import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  CheckCircleOutline as VerifiedIcon,
  ErrorOutline as DeclineIcon,
  Schedule as ScheduleIcon,
  Brightness2Outlined as InactiveIcon,
} from "@mui/icons-material";

import { colors } from "theme";
import { UserStatus } from "types/user";

const useStyles = makeStyles(() => ({
  container: {
    "& > svg, & > img": {
      width: 18,
      height: 18,
      marginRight: 6,
    },
    "& > h6": {
      fontWeight: 400,
      letterSpacing: 0.1,
    },
    "&.verified": {
      color: colors.semantic.positive,
    },
    "&.pending": {
      color: colors.semantic.warning,
    },
    "&.inactive": {
      color: colors.semantic.neutral,
    },
    "&.decline": {
      color: colors.nero[300],
    },
  },
}));

const icons: any = {
  decline: <DeclineIcon />,
  pending: <ScheduleIcon />,
  verified: <VerifiedIcon />,
  inactive: <InactiveIcon />,
};

export const UserStatusBadge: React.FC<{ status: UserStatus }> = ({
  status,
}) => {
  const classes = useStyles();
  const userStatus = UserStatus[status];

  return (
    <Box
      display="flex"
      alignItems="center"
      className={`${classes.container} ${userStatus.toLowerCase()}`}
    >
      {icons[userStatus.toLowerCase()]}
      <Typography variant="subtitle2">{userStatus}</Typography>
    </Box>
  );
};
